import { createSlice } from "@reduxjs/toolkit"

const initialState = {
    categories: null,
}

const categorySlice = createSlice({
  name: "category",
  initialState,
  reducers: {
    
    setCategories: (state, action) => {
      state.course = action.payload
    },
   
  },
})

export const {
    setCategories,
   } = categorySlice.actions

export default categorySlice.reducer;
